module.exports = __webpack_public_path__ + "static/img/1.cc27f6db.png";